import * as Dialog from "@radix-ui/react-dialog";

import styled from "styled-components";
import { Button } from "./ui/button";
import { Cross2Icon } from "@radix-ui/react-icons";

const formatDate = (value?: string) => {
  if (!value) {
    return "N/A";
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }

  return parsed.toLocaleString();
};

const formatValue = (value: unknown) => {
  if (value === null || value === undefined || value === "") {
    return "N/A";
  }

  if (typeof value === "object") {
    try {
      return JSON.stringify(value, null, 2);
    } catch {
      return "N/A";
    }
  }

  return String(value);
};

const TransferDetails = ({
  open,
  handleClose,
  details,
}: {
  open: boolean;
  handleClose: () => void;
  details: any;
}) => {
  const walletNumber =
    details?.wallet_number ||
    details?.sender_wallet_number ||
    details?.receiver_wallet_number ||
    "N/A";

  const rows = [
    ["Wallet Number", walletNumber],
    ["Recipient Wallet", details?.receiver_wallet_number],
    ["Date", formatDate(details?.created_at)],
    ["Reference", details?.reference],
    ["Transaction ID", details?.id],
    ["Amount", details?.amount],
    ["Currency", details?.currency_code],
    ["Charges", details?.charges],
    ["Channel", details?.channel],
    ["Transaction Type", details?.transaction_type],
    ["Mode", details?.debit_or_credit],
    ["Status", details?.status],
    ["Description", details?.description],
  ];

  return (
    <Dialog.Root
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          handleClose();
        }
      }}
    >
      <Dialog.Portal>
        <Dialog.Overlay className="DialogOverlay" />
        <DialogContent className="DialogContentSmall">
          <Dialog.Title className="DialogTitle">Transaction Details</Dialog.Title>

          <div style={{ display: "flex", flexDirection: "column", marginTop: 25, gap: "0.9rem" }}>
            <div className="rounded-2xl border border-slate-200 bg-slate-50/80 p-4">
              <p className="text-[11px] uppercase tracking-[0.18em] text-slate-500">Summary</p>
              <p className="mt-2 text-lg font-semibold text-slate-900">{walletNumber}</p>
              <p className="mt-1 text-sm text-slate-500">
                {details?.transaction_type || "Transaction"} {details?.status ? `• ${details.status}` : ""}
              </p>
            </div>

            <div className="grid gap-3">
              {rows.map(([label, value]) => (
                <Row key={label}>
                  <Item className="font-semibold text-slate-600">{label}</Item>
                  <Item>{formatValue(value)}</Item>
                </Row>
              ))}
            </div>
          </div>
          <Dialog.Close asChild>
            <CloseIconButton className="IconButton" aria-label="Close" onClick={handleClose}>
              <Cross2Icon width="20" height="20" />
            </CloseIconButton>
          </Dialog.Close>

          <div style={{ display: "flex", marginTop: 25, justifyContent: "flex-end" }}>
            <Dialog.Close asChild>
              <StyledButton
                onClick={() => window.print()}
                type="submit"
                className="flex items-center justify-center py-2 rounded-md bg-red-500 px-6 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-400"
              >
                Print
              </StyledButton>
            </Dialog.Close>
          </div>
          <Dialog.Close asChild>
            <CloseIconButton onClick={handleClose} className="IconButton" aria-label="Close">
              <Cross2Icon width="20" height="20" />
            </CloseIconButton>
          </Dialog.Close>
        </DialogContent>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

const CloseIconButton = styled.button`
  @media print {
    display: none;
  }
`;

const StyledButton = styled(Button)`
  @media print {
    display: none;
  }
`;

const DialogContent = styled(Dialog.Content)`
  max-height: 90vh;
  overflow-y: auto;

  @media print {
    width: 100vw;
    heigt: 100vh;
  }
`;

const Row = styled.div`
  display: flex;
  align-items: flex-start;
  border-bottom: 1px solid #eee;
  width: 100%;
  padding: 0.5rem;
  gap: 0.75rem;
`;

const Item = styled.div`
  width: 50%;
  white-space: pre-wrap;
  word-break: break-word;
`;

export default TransferDetails;
